import { motion } from "framer-motion";
import { CandyOff, WheatOff, DnaOff, Beef, Vegan, Sprout } from "lucide-react";
import { useLang } from "../../lib/i18n";

const STATS = [["102", "Magnesium"], ["45", "Potassium"], ["39", "Sodium"], ["335", "Chloride"]];
const ICONS = [null, CandyOff, WheatOff, Sprout, DnaOff, Beef, Vegan, "cor"];

const Badge = ({ icon: Icon, label, i }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.2 + i * 0.07, type: "spring", stiffness: 220, damping: 16 }}
    whileHover={{ y: -3 }}
    className="flex flex-col items-center gap-1.5 text-center"
    data-testid={`hero-badge-${i}`}
  >
    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#073B4C] text-[#FBF7EF]">
      {Icon === null && <span className="font-display text-lg leading-none">70+</span>}
      {Icon === "cor" && <span className="font-mono-x text-[10px] font-medium leading-none">COR</span>}
      {typeof Icon === "object" && Icon && <Icon className="h-5 w-5" />}
    </span>
    <span className="text-[11px] font-semibold uppercase leading-tight tracking-wide text-[#073B4C]">{label}</span>
  </motion.div>
);

export const ProductBadges = () => {
  const { t } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="rounded-3xl border border-white/70 bg-white/60 p-4 shadow-[0_20px_60px_-30px_rgba(7,59,76,0.5)] backdrop-blur-xl"
      data-testid="hero-product-badges"
    >
      <div className="grid grid-cols-4 gap-2 border-b border-[#073B4C]/15 pb-4 sm:grid-cols-2 sm:gap-y-4">
        {STATS.map(([n], i) => (
          <div key={n} className="text-center" data-testid={`hero-badge-stat-${i}`}>
            <p className="font-display text-2xl leading-none text-[#073B4C] sm:text-3xl">{n}<span className="text-sm">mg</span></p>
            <p className="mt-1 text-[11px] text-[#3F5F68]">{t.stats.items[i]}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-4 gap-x-2 gap-y-4 pt-4 sm:grid-cols-2">
        {ICONS.map((ic, i) => <Badge key={i} icon={ic} label={t.hero.badges[i]} i={i} />)}
      </div>
    </motion.div>
  );
};
